import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalComponent } from 'src/app/global-component';
import {
  ExtendedBaseInterface,
  ISearchRequest,
} from 'src/app/store/Authentication/auth.models';
import { environment } from 'src/environments/environment';

const env = environment.API_URL;

@Injectable({ providedIn: 'root' })
export class ContactQueriesService {
  constructor(private http: HttpClient) {}

  getContactQueries(data: ISearchRequest) {
    return this.http.get<ExtendedBaseInterface>(
      `${env}Home/GetContactUs?PageNumber=${data.PageNumber}&PageSize=${data.PageSize}&SortColumn=${data.SortColumn}&SortOrder=${data.SortOrder}&Search=${data.Search}`
    );
  }
}
